(() => {
if(window.skwPersonalizationBound)return;window.skwPersonalizationBound=true;
const q='[data-skw-personalization]';
const clean=(el)=>{
 if(!el.hasAttribute('data-preserve-lines'))return el.value.trim().split(' ').filter(Boolean).join(' ');
 const rows=el.value.replaceAll(String.fromCharCode(13),'').split(String.fromCharCode(10)).map(x=>x.trim().split(' ').filter(Boolean).join(' '));
 while(rows[0]==='')rows.shift();while(rows[rows.length-1]==='')rows.pop();return rows.join(String.fromCharCode(10));
};
const count=(el)=>{const c=el.closest('[data-skw-personalization-field]')?.querySelector('[data-skw-personalization-count]');if(c)c.textContent=el.value.length;};
const valid=(el)=>{
 el.setCustomValidity('');const v=clean(el);
 if(el.required&&!v){el.setCustomValidity(el.dataset.error||'Bitte Personalisierung eingeben.');return false}
 const m=Number(el.dataset.maxLines||0),lines=v?v.split(String.fromCharCode(10)).length:0;
 if(m&&lines>m){el.setCustomValidity(el.dataset.linesError||'Zu viele Zeilen.');return false}
 el.value=v;count(el);return true;
};
document.addEventListener('input',e=>{const el=e.target.closest?.(q);if(!el)return;el.setCustomValidity('');count(el)});
document.addEventListener('submit',e=>{const f=e.target;if(!(f instanceof HTMLFormElement))return;for(const el of f.querySelectorAll(q)){if(valid(el))continue;e.preventDefault();e.stopImmediatePropagation();el.reportValidity();el.focus();return}},true);
document.querySelectorAll(q).forEach(count);
})();